import React from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { formatExecutionTime, formatRefreshedAt } from '../services/aiFormatters';

export default function ResultMetaBar({
  executionTimeMs,
  executedAt,
  truncated,
  rowCount,
  onRefresh,
  refreshing,
  onExport,
  exportDisabled
}) {
  const executionLabel = formatExecutionTime(executionTimeMs);
  const refreshedLabel = formatRefreshedAt(executedAt);
  const truncatedLabel = truncated && rowCount != null ? `Result truncated to ${rowCount} rows` : null;

  if (!executionLabel && !refreshedLabel && !truncatedLabel && !onRefresh && !onExport) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mt: 0.5,
        flexWrap: 'wrap'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {executionLabel && (
          <Typography variant="caption" color="text.secondary">
            Executed in {executionLabel}
          </Typography>
        )}
        {refreshedLabel && (
          <Typography variant="caption" color="text.secondary">
            Last refreshed {refreshedLabel}
          </Typography>
        )}
        {truncatedLabel && (
          <Typography variant="caption" color="text.secondary">
            {truncatedLabel}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {onExport && (
          <Button
            size="small"
            startIcon={<FileDownloadIcon fontSize="small" />}
            onClick={onExport}
            disabled={Boolean(exportDisabled)}
            sx={{ textTransform: 'none' }}
          >
            Export to Excel
          </Button>
        )}
        {onRefresh && (
          <Button
            size="small"
            startIcon={refreshing ? <CircularProgress size={14} /> : <RefreshIcon fontSize="small" />}
            onClick={onRefresh}
            disabled={refreshing}
            sx={{ textTransform: 'none' }}
          >
            {refreshing ? 'Refreshing…' : 'Refresh data'}
          </Button>
        )}
      </Box>
    </Box>
  );
}
